/* eslint no-undef: 0 */
__webpack_public_path__ = `${window.Lidarr.urlBase}/`;
